// Theme-aware Recharts tooltip styles. Using CSS custom properties (which flip
// with `html.light`) means the tooltip popover adapts to light/dark automatically
// instead of being stuck on a hardcoded black background.
export const tooltipStyle = {
  background: "hsl(var(--popover))",
  border: "1px solid hsl(var(--border))",
  color: "hsl(var(--popover-foreground))",
  fontFamily: "JetBrains Mono",
  fontSize: 11,
  padding: "4px 8px",
  borderRadius: 0,
  boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
};

export const tooltipLabelStyle = { color: "hsl(var(--muted-foreground))", fontSize: 10 };
